import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Heroku extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M20.64,0H3.36A2.16,2.16,0,0,0,1.2,2.16V21.84A2.16,2.16,0,0,0,3.36,24H20.64a2.16,2.16,0,0,0,2.16-2.16V2.16A2.16,2.16,0,0,0,20.64,0ZM6.6,20.4V15.6L9.3,18Zm8.4,0V13.233c-.012-.56-.281-1.233-1.5-1.233a15.027,15.027,0,0,0-5.2,1.24l-1.7.768V3.6H9v6.813A15.187,15.187,0,0,1,13.5,9.6a3.855,3.855,0,0,1,2.855,1.073A3.742,3.742,0,0,1,17.4,13.2v7.2Zm.6-12.9H13.2A9.341,9.341,0,0,0,15,3.6h2.4A7.034,7.034,0,0,1,15.6,7.5Z" />
      </svg>
    );
  }
}

export default Heroku;
